import axios from 'axios'
import { cleanIdrFormat } from '@/_helpers'
import BaseModel from '@/models/BaseModel.js'

export default class Sale extends BaseModel {
    fields =  {
      'costumer_id': {
        label: 'costumer_id',
        type: 'hidden',
        // rules: 'required'
      },
      'tanggal_transaksi': {
        label: 'Tanggal',
        type: 'date',
        rules: 'required'
      },
      'panjar': {
        label: 'Panjar',
        type: 'hidden',
        rules: null
      },
      'sisa': {
        label: 'Sisa',
        type: 'hidden',
        disableSelection: true,
        rules: null
      },
      'metode_pembayaran': {
        label: 'Metode pembayaran',
        type: 'enum',
        value: 'cash',
        options: {
          'cash': 'Cash',
          'transfer': 'Transfer',
          'edc': 'Edc',
          'qris': 'QRIS',
        },
        rules: 'required'
      },
      'status_bayar': {
        label: 'Status',
        type: 'hidden',
        rules: null
      },
      'catatan': {
        label: 'Catatan',
        type: 'textarea',
        rules: null
      },
    }
    endpoint = process.env.VUE_APP_API_URL + 'sales'

    create (value) {
      return new Promise((resolve, reject) => {
        let formData =this.initForEndpoint(value, true)
        // Explicitly send a valid initial approval status. The API only accepts
        // draft or on_review when creating a sale; the Draft button must never
        // rely on an omitted/undefined value being inferred by the backend.
        formData.append('approval_status', value.approval_status || 'draft')
        let i = 0;
        Object.keys(value.details).forEach(key => {
          formData.append(`detail_barang[${i}][qty]`, 1)
          Object.keys(value.details[key]).forEach(id => {
            if (typeof value.details[key][id] !== 'undefined' && value.details[key][id] !== null) {
              if (value[key] instanceof File) {
                formData.append(`detail_barang[${i}][${id}]`, value.details[key][id], value.details[key][id].name)
              } else {
                formData.append(`detail_barang[${i}][${id}]`, id === 'harga_jual' ? cleanIdrFormat(value.details[key][id]) : value.details[key][id])
              }
            }
          })
          i++;
        });
        axios.post(this.endpoint, formData).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
    update (id, value) {
      return new Promise((resolve, reject) => {
        let formData = this.initForEndpoint(value, true)
        let i = 0;
        Object.keys(value.details).forEach(key => {
            if (value.details[key].id) {
              formData.append(`detail_barang[${i}][id]`, value.details[key].id)
            }
            formData.append(`detail_barang[${i}][qty]`, 1)
            Object.keys(value.details[key]).forEach(id => {
              if (typeof value.details[key][id] !== 'undefined' && value.details[key][id] !== null) {
                if (value[key] instanceof File) {
                  formData.append(`detail_barang[${i}][${id}]`, value.details[key][id], value.details[key][id].name)
                } else {
                  formData.append(`detail_barang[${i}][${id}]`, id === 'harga_jual' ? cleanIdrFormat(value.details[key][id]) : value.details[key][id])
                }
              }
            })
            i++;
          // }
        });

        i = 0
        value.deleted_ids.forEach(deleted_id => {
          formData.append(`deleted_ids[${i}]`, deleted_id)
          i++;
        });

        formData.append('_method', 'PATCH')
        axios.post(this.endpoint + '/' + id, formData).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }

    submit (id) {
      return axios.patch(this.endpoint + '/' + id + '/submit').then(response => response.data)
    }

    approve (id, reviewNote = null) {
      return axios.patch(this.endpoint + '/' + id + '/approve', { review_note: reviewNote }).then(response => response.data)
    }

    returnForRevision (id, reviewNote) {
      return axios.patch(this.endpoint + '/' + id + '/return', { review_note: reviewNote }).then(response => response.data)
    }

    reject (id, reviewNote) {
      return axios.patch(this.endpoint + '/' + id + '/reject', { review_note: reviewNote }).then(response => response.data)
    }
}
